import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const SchemaOrgJSONLD = ({
                           url,
                           title,
                         }) => {
  const schemaOrgJSONLD = [
    {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url,
      name: title,
    },
  ];
  return <Helmet>
    <script type="application/ld+json">
      {JSON.stringify(schemaOrgJSONLD)}
    </script>
  </Helmet>;
};

SchemaOrgJSONLD.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default SchemaOrgJSONLD;


// WEBPACK FOOTER //
// ./src/components/Head/JSONLD.js